import {Trans} from '@lingui/macro';
import React, {ReactNode} from 'react';

import {TabButtonElement} from '../../../analytics/components/tabs/tabButtonElement';
import {useLinkNavigation} from '../../../components/common/navigation/useLinkNavigation';
import {useAppSelector} from '../../../helpers/reduxHelpers';
import {SettingsCustomFieldsPagesEnum} from '../../../models/url/settingsUrlModel';
import {getHasNewContactsManagerAccounts} from '../../../store/featureFlags/featureFlagsSelectors';
import {SettingsHeader} from '../../settingsHeader';
import {getCustomFieldsBaseUrl} from '../customFieldsHelpers';
import {CustomFieldsResourceName} from './customFieldsResourceName';

/*
 * Types.
 */

interface CustomFieldsTabsProps {
  tabPage: SettingsCustomFieldsPagesEnum;
  right: ReactNode;
}

/*
 * Component.
 */

export const CustomFieldsTabs = ({tabPage, right}: CustomFieldsTabsProps) => {
  const {navigateToLink} = useLinkNavigation();
  const hasNewContactsManagerAccounts = useAppSelector(getHasNewContactsManagerAccounts);

  function maybeRenderAccountTab() {
    if (!hasNewContactsManagerAccounts) {
      return null;
    }

    return (
      <TabButtonElement
        interactionId="settings-custom-fields-accounts-tab"
        name={
          <CustomFieldsResourceName tabPage={SettingsCustomFieldsPagesEnum.ACCOUNTS} capitalizeFirstLetter />
        }
        isSelected={tabPage === SettingsCustomFieldsPagesEnum.ACCOUNTS}
        onTabClick={() =>
          navigateToLink(`${getCustomFieldsBaseUrl(SettingsCustomFieldsPagesEnum.ACCOUNTS)}/overview`)
        }
      />
    );
  }

  const renderTabs = () => (
    <>
      <TabButtonElement
        interactionId="settings-custom-fields-contacts-tab"
        name={
          <CustomFieldsResourceName tabPage={SettingsCustomFieldsPagesEnum.CARDS} capitalizeFirstLetter />
        }
        isSelected={tabPage === SettingsCustomFieldsPagesEnum.CARDS}
        onTabClick={() =>
          navigateToLink(`${getCustomFieldsBaseUrl(SettingsCustomFieldsPagesEnum.CARDS)}/overview`)
        }
      />
      {maybeRenderAccountTab()}
      <TabButtonElement
        interactionId="settings-custom-fields-teammates-tab"
        name={
          <CustomFieldsResourceName tabPage={SettingsCustomFieldsPagesEnum.TEAMMATES} capitalizeFirstLetter />
        }
        isSelected={tabPage === SettingsCustomFieldsPagesEnum.TEAMMATES}
        onTabClick={() =>
          navigateToLink(`${getCustomFieldsBaseUrl(SettingsCustomFieldsPagesEnum.TEAMMATES)}/overview`)
        }
      />
      <TabButtonElement
        interactionId="settings-custom-fields-inboxes-tab"
        name={
          <CustomFieldsResourceName tabPage={SettingsCustomFieldsPagesEnum.INBOXES} capitalizeFirstLetter />
        }
        isSelected={tabPage === SettingsCustomFieldsPagesEnum.INBOXES}
        onTabClick={() =>
          navigateToLink(`${getCustomFieldsBaseUrl(SettingsCustomFieldsPagesEnum.INBOXES)}/overview`)
        }
      />
    </>
  );

  return (
    <SettingsHeader right={right} tabs={renderTabs()}>
      <Trans id="settings-custom-fields-header">Custom Fields</Trans>
    </SettingsHeader>
  );
};
